import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ListarComposicaoModel } from "../models/composicao/listarComposicaoModel";
import { SalvarComposicaoModel } from "../models/composicao/salvarComposicaoModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";

export const listarComposicao = createAsyncThunk("/Composicao/ListarComposicao", async (args: ListarComposicaoModel) => {
  try {
    const data = await api.get("/Composicao/ListarComposicao", { params: args });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarComposicao = createAsyncThunk("/Composicao/AtualizarComposicao", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/Composicao/AtualizarComposicao", payload.value);
    toastSucess("A solicitação da composição foi enviada com sucesso");
    dispatch(setLoading(false));

    dispatch(listarComposicao(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const verificarComposicaoSalva = createAsyncThunk("/Composicao/VerificarComposicaoSalva", async (args: ListarComposicaoModel) => {
  try {
    const data = await api.get("/Composicao/VerificarComposicaoSalva", { params: args });
    return data.data.data ?? null;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const salvarComposicao = createAsyncThunk("/Composicao/SalvarComposicao", async (payload: { value: SalvarComposicaoModel; busca: ListarComposicaoModel }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/Composicao/SalvarComposicao", payload.value);
    toastSucess("Composição de resultado salva com sucesso");
    dispatch(setLoading(false));

    dispatch(verificarComposicaoSalva(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const listarComposicoesSalvas = createAsyncThunk("/Composicao/ListarComposicoesSalvas", async () => {
  try {
    const data = await api.get("/Composicao/ListarComposicoesSalvas");
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const obterComposicaoSalva = createAsyncThunk("/Composicao/ObterComposicaoSalva", async (id: number) => {
  try {
    const data = await api.get("/Composicao/ObterComposicaoSalva", { params: { id } });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});
